import $ from "jquery";

import utils from "../helpers/utils";

function init(): void {
  const $showcase = $(".js-showcase");
  if ($showcase.length) {
    $showcase.click(function () {
      const hidden = !$(this).hasClass("shown");
      $showcase.removeClass("shown"); // Hide all showcases

      // Was it hidden already? If so, show it now!
      if (hidden) {
        utils.addClass(this, "shown");
      }

      return false;
    });
  }
}

export default { init };
